import React, { useContext, useState } from 'react';
import TableActionButton from '../../../../../../components/buttons/tableActionButton';
import { TableUpdateContext } from '../../../../../../contexts/reviewTypeContext';
import Alert from '../../../../../../utils/alert';
import { usePeerBranchesActions } from '../../../contexts/peersReportsContext';
import { collectPeerLabelConversions, savePeerLabelConversions } from '../../../utils/peerLabelConversions';

export default function AcceptLabelConversionsButton(props) {
    const update = useContext(TableUpdateContext);
    if (props.readOnly || !update?.updateId) {
        return null;
    }
    return <ConversionButton {...props} updateId={update.updateId} />;
}

function ConversionButton({
    className,
    getReports,
    descriptors,
    schemaId,
    schemaName,
    updateId,
    onChange,
}) {
    const { getPeerReportDiffDetector, addReconciliationEvents } = usePeerBranchesActions();
    const [loading, setLoading] = useState(false);

    const accept = async () => {
        const batches = collectPeerLabelConversions({
            reports: getReports(),
            descriptors,
            schemaId,
            schemaName,
            getPeerReportDiffDetector,
        });
        if (!batches.length) {
            return;
        }
        setLoading(true);
        try {
            const result = await savePeerLabelConversions(batches, updateId, addReconciliationEvents);
            if (result.failure) {
                const { reportId, stage, savedLabelCount } = result.failure;
                const reason =
                    stage === 'events'
                        ? `${savedLabelCount} labels in report ${reportId} were saved, but their acceptance events could not be recorded.`
                        : `Could not save report ${reportId}.`;
                Alert.warn(`${result.acceptedCount} labels accepted. ${reason} Processing stopped.`);
            } else {
                Alert.success(`Labels accepted.`);
            }
        } catch {
            Alert.warn('Could not complete label conversions.');
        } finally {
            setLoading(false);
            onChange();
        }
    };

    return (
        <TableActionButton
            type="button"
            onClick={accept}
            disabled={loading}
            aria-busy={loading}
            className={className}
        >
            {loading ? 'Accepting labels...' : 'Accept label conversions'}
        </TableActionButton>
    );
}
